import { useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import { Spinner, Center } from '@chakra-ui/react';
import { useStores } from '../store/store_context';

const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();
  const { pageStore } = useStores();
  const [checking, setChecking] = useState(!pageStore.authReady);

  useEffect(() => {
    let active = true;
    const check = async () => {
      if (!pageStore.authReady) await pageStore.initializeSession();
      else if (pageStore.token && !pageStore.username) await pageStore.getMe();
      if (!active) return;
      setChecking(false);
      if (!pageStore.token) navigate('/');
    };
    check();
    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    if (!checking && !pageStore.token) navigate('/');
  }, [checking, pageStore.token]);

  if (checking) {
    return (
      <Center minH="100vh" bg="#0f0f1c">
        <Spinner color="white" />
      </Center>
    );
  }

  return <>{children}</>;
};

export default PrivateRoute;
